import React from "react";
import { PageHero } from "../../components/public/Section";

export default function Terms() {
  return (
    <div>
      <PageHero title="Terms & Conditions" breadcrumbs={["Home", "Terms"]} />
      <section className="section container-page max-w-3xl space-y-6 text-brand-text leading-relaxed">
        <p>By accessing or using this website, you agree to be bound by these Terms & Conditions. Please read them carefully.</p>
        <h3 className="font-serif text-xl font-bold">Use of Content</h3>
        <p>All content on this website, including text, images and logos, is the property of Ghaziabad Ophthalmological Society unless otherwise noted. Reproduction without permission is not allowed.</p>
        <h3 className="font-serif text-xl font-bold">Medical Disclaimer</h3>
        <p>Information provided on this website is intended for professional and educational purposes and does not constitute medical advice. Please consult a qualified ophthalmologist for personal medical concerns.</p>
        <h3 className="font-serif text-xl font-bold">Membership</h3>
        <p>Membership is subject to eligibility and approval by the Executive Committee. Membership privileges are governed by the Society's bye-laws.</p>
        <h3 className="font-serif text-xl font-bold">Modifications</h3>
        <p>GOS reserves the right to modify these terms at any time. Continued use of the website constitutes acceptance of the updated terms.</p>
      </section>
    </div>
  );
}
